export default __webpack_public_path__ + "static/media/476.8e88046b.jpg";